export default __webpack_public_path__ + "static/christmas-2bd25e491e240c4b3c026c42147f000b.jpg";